import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { StarRating } from '@/components/ui/star-rating';
import { format } from 'date-fns';

export interface Review {
  id: string;
  comment: string;
  overallRating: number;
  author: {
    id: string;
    firstName: string;
    imageUrl: string;
  };
  publishedAt: Date;
}

const Review = ({ review }: { review: Review }) => (
  <div className="border-b last:border-0 pb-4">
    <div className="flex items-center gap-4">
      <Avatar>
        <AvatarImage src={review.author.imageUrl} />
        <AvatarFallback>{review.author.firstName[0]}</AvatarFallback>
      </Avatar>
      <div className="flex-1 items-center">
        <div className="flex justify-between">
          <div className="flex items-center gap-2">
            <p className="font-medium">{review.author.firstName}</p>
          </div>
          <div className="flex items-end flex-col">
            <p className="text-sm text-muted-foreground">
              {format(new Date(review.publishedAt), 'MMMM yyyy')}
            </p>
            <div className="flex items-center gap-1">
              <StarRating value={review.overallRating} className="w-4 h-4 text-yellow-600" />
            </div>
          </div>
        </div>
        <p className="text-sm">{review.comment}</p>
      </div>
    </div>
  </div>
);

export default function PropertyReviewsList({
  reviews,
  showAll = false,
}: {
  reviews: Review[];
  showAll?: boolean;
}) {
  const displayedReviews = showAll ? reviews : reviews.slice(0, 3);

  return (
    <div className="space-y-4">
      {displayedReviews.map((review) => (
        <Review key={review.id} review={review} />
      ))}
    </div>
  );
}

// Add the Review component as a named export
PropertyReviewsList.Review = Review;
